var map = {
	"./en-SG": 905,
	"./en-SG.js": 905,
	"./en-au": 906,
	"./en-au.js": 906,
	"./en-ca": 907,
	"./en-ca.js": 907,
	"./en-gb": 908,
	"./en-gb.js": 908,
	"./en-ie": 909,
	"./en-ie.js": 909,
	"./en-il": 910,
	"./en-il.js": 910,
	"./en-nz": 911,
	"./en-nz.js": 911
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2287;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 2287
// module chunks = 1